var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCallingFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.93844,10.54329l-.60057.60058a40.28009,40.28009,0,0,0,5.51818,5.51818l.60058-.60058a1.69858,1.69858,0,0,1,2.40231,0l1.80258,1.80174a1.69858,1.69858,0,0,1,0,2.40231l-.98964.98879a2.54627,2.54627,0,0,1-3.20506.322A39.486,39.486,0,0,1,2.42366,10.5331a2.54417,2.54417,0,0,1,.3211-3.20592l.98879-.98879a1.70012,1.70012,0,0,1,2.40231,0L7.93844,8.14013A1.70115,1.70115,0,0,1,7.93844,10.54329ZM11.7677,2.9267a.46335.46335,0,0,1,0-.9267A10.23151,10.23151,0,0,1,22,12.2323a.46335.46335,0,0,1-.9267,0A9.30481,9.30481,0,0,0,11.7677,2.9267Zm0,3.39789a.46335.46335,0,1,1,0-.92669,6.834,6.834,0,0,1,6.83441,6.8344.46335.46335,0,1,1-.9267,0A5.90732,5.90732,0,0,0,11.7677,6.32459Zm0,3.3979a.46335.46335,0,0,1,0-.9267,3.436,3.436,0,0,1,3.43651,3.43651.46335.46335,0,0,1-.9267,0A2.50926,2.50926,0,0,0,11.7677,9.72249Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallingFull);
export default __webpack_public_path__ + "static/media/calling_full.73cd75a002903d1a58f73a514da2871d.svg";
export { ForwardRef as ReactComponent };